import './index.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Member from '../../entities/Member';

interface IProps {
  member: Member;
}

class ErrorRoutingComponent extends React.Component<IProps> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  render(): JSX.Element {
    return (
      <div id="Error404">
        <div>このページは存在しません。</div>
        <Link to="/">
          <div id="LinkToHome">ホームへ戻る</div>
        </Link>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  member: state.Member
});

const mapDispatchToProps = (dispatch: any) => {
  return {};
};

const ErrorRouting = connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorRoutingComponent);

export default ErrorRouting;



// WEBPACK FOOTER //
// ./src/components/ErrorRouting/index.tsx